module.exports = __webpack_public_path__ + "img/grey-trainings-2.8aaf8313.png";